module.exports = __webpack_public_path__ + "static/media/star-grey.1d6318fb.png";